import { gql } from '@apollo/client'
import { ID } from '../IQueryData'
import { ParkingSubscriptionStatus } from '../tenant/getTenant'

export enum ParkingPoolReservationsCancellation {
  day = 'day',
  any = 'any',
}

export enum ParkingPoolReservationsOrder {
  valid_from_desc = 'valid_from_desc',
  valid_from_asc = 'valid_from_asc',
  name_asc = 'name_asc',
  name_desc = 'name_desc',
  status_asc = 'status_asc',
  status_desc = 'status_desc',
  parking_asc = 'parking_asc',
  parking_desc = 'parking_desc',
  cancelled_at_asc = 'cancelled_at_asc',
  cancelled_at_desc = 'cancelled_at_desc',
}

export interface IParkingPoolCancelledDay {
  day: string
  cancelled_at?: string | null
  cancelled_by?: string | null
}

export interface IParkingPoolReservationRow {
  subscription_id: ID
  login: string
  first_name?: string | null
  last_name?: string | null
  email?: string | null
  card_number?: string | null
  parking?: string | null
  valid_from: string
  valid_to?: string | null
  status: string
  cancelled_at?: string | null
  cancelled_by?: string | null
  cancelled_days?: IParkingPoolCancelledDay[] | null
  total_days_count: number
}

export interface IParkingPoolReservationsStatusCount {
  status: string
  count: number
}

export interface IListParkingPoolReservationsVars {
  parking_pool: ID
  from: string
  to?: string
  status?: ParkingSubscriptionStatus[]
  search?: string
  cancellation?: ParkingPoolReservationsCancellation
  order?: ParkingPoolReservationsOrder
  first?: number
  offset?: number
}

export interface IListParkingPoolReservationsData {
  listParkingPoolReservations: {
    code: number
    status: boolean
    error?: string | null
    message?: string | null
    total_count: number
    status_counts?: IParkingPoolReservationsStatusCount[] | null
    rows?: IParkingPoolReservationRow[] | null
  }
}

export const LIST_PARKING_POOL_RESERVATIONS = gql`
  query listParkingPoolReservations(
    $parking_pool: ID!
    $from: DateTime!
    $to: DateTime
    $status: [ParkingSubscriptionStatus]
    $search: String
    $cancellation: ParkingPoolReservationsCancellation
    $order: ParkingPoolReservationsOrder
    $first: Int
    $offset: Int
  ) {
    listParkingPoolReservations(
      parking_pool: $parking_pool
      from: $from
      to: $to
      status: $status
      search: $search
      cancellation: $cancellation
      order: $order
      first: $first
      offset: $offset
    ) {
      code
      status
      error
      message
      total_count
      status_counts {
        status
        count
      }
      rows {
        subscription_id
        login
        first_name
        last_name
        email
        card_number
        parking
        valid_from
        valid_to
        status
        cancelled_at
        cancelled_by
        cancelled_days {
          day
          cancelled_at
          cancelled_by
        }
        total_days_count
      }
    }
  }
`

export const COUNT_PARKING_POOL_RESERVATIONS = gql`
  query countParkingPoolReservations(
    $parking_pool: ID!
    $from: DateTime!
    $to: DateTime
    $search: String
    $cancellation: ParkingPoolReservationsCancellation
  ) {
    listParkingPoolReservations(
      parking_pool: $parking_pool
      from: $from
      to: $to
      search: $search
      cancellation: $cancellation
      first: 1
    ) {
      code
      status
      total_count
    }
  }
`
